import { render, staticRenderFns } from "./ProductManageModal.vue?vue&type=template&id=63311875&scoped=true"
import script from "./ProductManageModal.vue?vue&type=script&lang=js"
export * from "./ProductManageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63311875",
  null
  
)

export default component.exports